import { DocumentUploadDialog } from "minimals-template/components/upload/document-upload-dialog"

export function CobieImportDialog({ ...props }) {
    return (
        <DocumentUploadDialog
            title="Add Assets via COBie File"
            fileSelectText="Select COBie File"
            acceptedFileFormat={{
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
            }}
            {...props}
        />
    )
}
